import React, { Component } from 'react'
import MappingSizeList from '../../../components/MappingSizeList'
import { SearchOptions } from '../../../components/TableHelper'
import { MappingSizeConsumer } from '../../../context/MappingSizeContext'

type MappingSizeProps = {
  filters: any | null,
  history: any,
  permissions: any,

  onLoad?: (searchOptions: SearchOptions) => void
}

export default class MappingSize extends Component<MappingSizeProps> {

  handleOnLoad = (searchOptions: SearchOptions) => {
    if (this.props.onLoad) {
      this.props.onLoad(searchOptions)
    }
  }

  render() {
    const { permissions, filters, history } = this.props

    return (
      <MappingSizeConsumer>
        {({ fetching, mappingSizes, pagination, requestMappingSizeList }) => {

          return <MappingSizeList permissions={permissions} loading={fetching} mappingSizes={mappingSizes} pagination={pagination} filters={filters} history={history} onLoad={this.handleOnLoad} loadMappingSizes={requestMappingSizeList} />
        }}
      </MappingSizeConsumer>
    )
  }
}
